import { useEffect, useState } from 'react'

export const useMobile = (maxWidth = 767) => {
  const [matches, setMatches] = useState(window.innerWidth < maxWidth)

  useEffect(() => {
    const media = window.matchMedia(`(max-width:  ${maxWidth}px)`)
    const onChange = (e) => setMatches(e.matches)

    media.addEventListener('change', onChange)

    return () => {
      media.removeEventListener('change', onChange)
    }
  }, [maxWidth])

  return matches
}

export default useMobile
